import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {Table, Button, Modal} from 'antd';
import {IP_APPEAL_QUESTION_OPTIONS, VERIFY_OPTIONS} from '../appeal/conf';
import {login, handleLogin} from '../../util';
import {fetchIpUserInfo} from '../../actions/ipAppealAction';

import {fetchIpDetailList} from '../../actions/ipAppealAction';

import './index.less';

export const ipQuestionStateErr = {
    ipQuestionTypeErr: '',
};

interface IProps {
    fetchIpUserInfo: () => void;
    fetchDataList: (params) => Promise<any>;
}

export function IpAppealList(props: IProps) {
    const {fetchIpUserInfo} = props;
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCurrent, setPageCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pageTotal, setPageTotal] = useState(0);
    const [ipData, setIpData] = useState([]);

    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0);
        handleLogin(fetchIpUserInfo);
    }, [location.pathname]);

    useEffect(() => {
        fetchDataList({
            page: 1,
            size: pageSize
        });
    }, []);

    const onPageChange = (page, size) => {
        if (page !== pageCurrent) {
            setPageCurrent(page);
            fetchDataList({page});
        }
        if (size !== pageSize) {
            setPageSize(1);
            fetchDataList({
                page: 1,
                limit: pageSize
            });
        }
    };

    const fetchDataList = (initialParam?: any) => {
        const param = {
            page: initialParam?.page || pageCurrent,
            size: initialParam?.size || pageSize,
        };
        const paramStr = `page=${param.page}&size=${param.size}`;
        setTableLoading(true);

        props.fetchDataList(paramStr).then(res => {
            if (res && res.code === 200) {
                setPageTotal(res.data.count);
                setIpData(res.data.list);
            } else if (res?.code === 401) {
                login();
            } else {
                Modal.warning({
                    title: '结果提示',
                    content: '请求失败，请稍后重试',
                    okText: '知道了',
                    centered: true
                });
            }
            setTableLoading(false);
        });
    };
    const columns = [{
        title: '申诉IP',
        dataIndex: 'ip',
        key: 'ip',
    }, {
        title: '问题类型',
        dataIndex: 'class',
        key: 'questionType',
        render: (_, rowValue) => {
            return IP_APPEAL_QUESTION_OPTIONS.find(item => item.value === rowValue.class)?.label || '--';
        }
    }, {
        title: '提交时间',
        dataIndex: 'created',
        key: 'created'
    }, {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: (_, rowValue) => {
            return VERIFY_OPTIONS.find(item => item.value === rowValue.status)?.label || '--';
        }
    }, {
        title: '操作',
        dataIndex: 'option',
        key: 'option',
        render: (_, rowValue) => {
            return (<div>
                <Button type="link" onClick={() => {
                    history.push(`/ip_appeal/detail/${rowValue.id}`);
                }}>
                    查看
                </Button>
            </div>);
        }
    }];
    return (<div className="ip-appeal-page">
        <div className="top-banner">
            <div className={'carousel-item ip-appeal-banner'}>
                <div className="item-info-wrapper">
                    <span className="title">百度智能云·IP风险画像·信息报错-反馈进度查询</span>
                </div>
            </div>
        </div>
        <div className="ip-appeal-list">
            <div className="table-list">
                <Table
                    dataSource={ipData}
                    columns={columns}
                    loading={tableLoading}
                    rowKey={record => record.id}
                    pagination={{
                        total: pageTotal,
                        pageSize: pageSize,
                        current: pageCurrent,
                        onChange: onPageChange,
                        position: ['bottomCenter']
                    }}
                />
            </div>
        </div>
    </div>);
}

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}
function mapDispatchToProps(dispatch) {
    return {
        fetchDataList: (param) => fetchIpDetailList(dispatch, param),
        fetchIpUserInfo: () => fetchIpUserInfo(dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IpAppealList as any));


